"use client";

import { useEffect, useRef } from "react";
import { mountScrollReveal } from "./scroll-reveal-engine";

/** Small client island; the website's content remains server-rendered. */
export function ScrollReveal({ enabled = true, revision }: { enabled?: boolean; revision: string }) {
  const marker = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    const root = marker.current?.closest<HTMLElement>(".website-design");
    if (enabled && root) return mountScrollReveal(root);
  }, [enabled, revision]);
  return <span ref={marker} hidden aria-hidden="true" data-scroll-reveal-controller=""/>;
}
